export const environment = {
  production: true,
  apiUrl: 'https://rptmngapiv2.clavisco.com/',
};
